/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const JijiaDeviceVerify = {
  path: '/jijia-device-verify',
  name: 'jijia-device-verify',
  redirect: { name: 'jijia-device-verify-order' },
  component: () => import('@/views/jijia-device-verify/index.vue'),
  children: [
    {
      path: 'order',
      name: 'jijia-device-verify-order',
      component: () =>
        import(
          /* webpackChunkName: "jijia-device-verify" */ '@/views/jijia-device-verify/order.vue'
        ),
    },
    {
      path: 'search',
      name: 'jijia-device-verify-search',
      component: () =>
        import(
          /* webpackChunkName: "jijia-device-verify" */ '@/views/jijia-device-verify/search.vue'
        ),
    },
    {
      path: 'order-detail',
      name: 'jijia-device-verify-order-detail',
      component: () =>
        import(
          /* webpackChunkName: "jijia-device-verify" */ '@/views/jijia-device-verify/order-detail.vue'
        ),
    },
  ],
}
export default JijiaDeviceVerify
